__turbopack_context__.v({
  "container": "HB5Z3q_container",
  "ghost": "HB5Z3q_ghost",
  "isCircle": "HB5Z3q_isCircle",
  "isDisabled": "HB5Z3q_isDisabled",
  "isNegative": "HB5Z3q_isNegative",
  "large": "HB5Z3q_large",
  "loader": "HB5Z3q_loader",
  "medium": "HB5Z3q_medium",
  "onlyIcon": "HB5Z3q_onlyIcon",
  "primary": "HB5Z3q_primary",
  "rotation": "HB5Z3q_rotation",
  "secondary": "HB5Z3q_secondary",
  "small": "HB5Z3q_small",
  "tertiary": "HB5Z3q_tertiary",
});
